__turbopack_context__.v({
  "schedule": "oszW2q_schedule",
  "schedule__hdr": "oszW2q_schedule__hdr",
  "schedule__hdrTitle": "oszW2q_schedule__hdrTitle",
  "schedule__hdr__btn": "oszW2q_schedule__hdr__btn",
  "schedule__iframe": "oszW2q_schedule__iframe",
});
